<template>
  <div>
    <el-button size="mini" @click="allRead">全部標示為已讀</el-button>
    <el-table
      stripe
      :data="dataList"
      border
      style="width: 100%;margin-top:18px"
    >
      <el-table-column
        header-align="center"
        align="center"
        prop="index"
        label="序"
        type="index"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="type_alias"
        label="標題"
      >
        <template slot-scope="scope">
          <div class="pointer" @click="showContent(scope.row)">
            {{ scope.row.data.message.title }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="created_at"
        label="時間"
      >
      </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        :current-page.sync="page"
        layout="prev, pager, next"
        :page-count="pagination.total_page"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      inSearch: false,
      saveData: false,
      searchData: {},
      dataList: [],
      pagination: {}
    };
  },
  methods: {
    allRead() {
      this.$http.get(`/back/users/notifications/allAsRead`).then(res => {
        if (res.data.code == 0) {
          this.$message.success("成功");
          this.getData();
        }
      });
    },
    showContent(data) {
      this.$http.post(`/back/users/notifications/markAsRead`, { id: data.id });
      this.$alert(data.data.message.content, data.data.message.title, {
        dangerouslyUseHTMLString: true
      });
    },
    getData() {
      let searchData = {};
      if (this.saveData) {
        searchData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        searchData = JSON.parse(JSON.stringify(this.searchData));
        if (this.currentDate) {
          searchData.date_start = this.currentDate[0];
          searchData.date_end = this.currentDate[1];
        }
        searchData.lifting_time =
          this.radio == 1 ? "created_at" : "completed_at";
      }
      Object.keys(searchData).forEach(e => {
        if (!searchData[e] && String(searchData[e]) !== "0") {
          delete searchData[e];
        }
      });
      searchData.page = this.page;
      this.$http
        .get(`/back/users/notifications/unread`, { params: searchData })
        .then(res => {
          if (res.data.code == 0) {
            this.saveData = JSON.parse(JSON.stringify(searchData));
            this.inSearch = false;
            this.dataList = res.data.data;
            this.pagination = res.data.paginate;
          }
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>
